<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{ element_group && element_group.data.attributes.name }}</h1>
    </div>
    <div class="tabs">
      <div class="wrapper-x-40">
        <router-link
          :class="{ active: isListRoute }"
          class="focus:outline-none"
          :to="{
            name: 'engravings',
            params: { slug },
            query: { ...$route.query },
          }"
        >
          {{ $t("main.tab_list") }}
        </router-link>
        <router-link
          v-if="licensed"
          :class="{ active: isTypesRoute }"
          class="focus:outline-none"
          :to="{
            name: 'engravings_types',
            params: { slug },
            query: { ...$route.query },
          }"
        >
          {{ $t("main.tab_types") }}
        </router-link>
      </div>
    </div>
    <div class="content">
      <AdminTypesList />
    </div>
  </div>
</template>

<script>
import AdminTypesList from "../../../components/Admin/Types/List";

export default {
  name: "TypesList",
  components: { AdminTypesList },
  computed: {
    slug() {
      return this.$route.params.slug;
    },
    element_group() {
      return this.$store.state.elements.element_group;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
    isListRoute() {
      return this.$route.name === "engravings";
    },
    isTypesRoute() {
      return this.$route.name === "engravings_types";
    },
  },
};
</script>
